import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'lp-own-products-header',
  templateUrl: './lp-own-products-header.component.html',
  styleUrls: ['./lp-own-products-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpOwnProductsHeaderComponent extends BaseResizableComponent {
  @Input() title?: string;
  @Input() allowCreating = false;
  @Input() allowAllStatisticsViewing = false;
  @Output() add = new EventEmitter();
}
